import { Injectable } from '@angular/core';
import { UserService } from '@app/user/services';
import { PATHS } from '@shared/constants/paths';
import { NavigationHelperService } from '@shared/helpers/navigation.helpers.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MppGuardService {
  constructor(
    private userService: UserService,
    private navigationHelperService: NavigationHelperService,
  ) {}

  /** Navigates to appropriate route based on user platform, always returns false */
  canActivate(): Observable<boolean> {
    return this.userService.showMPPMoxe.pipe(
      map(canMPP => {
        if (canMPP) {
          return true;
        } else {
          this.navigationHelperService.routeTo(PATHS.HOME);
          return false;
        }
      }),
    );
  }
}
